import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface CommentCountProps {
  count: number;
  className?: string;
}

export default function CommentCount({ count, className }: CommentCountProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-1 text-base",
        className
      )}
    >
      <MessageCircle size={16} className="text-gray-400" />
      <span className="font-semibold text-sm">{count}</span>
    </div>
  );
}
